import type { EnrichmentOperatorStatsTotal } from "@/api/enrichment";
import { formatEnrichmentMoney } from "@/lib/enrichmentMoney";

interface EnrichmentPayoutSummaryProps {
  total: EnrichmentOperatorStatsTotal;
  currency: string;
  scope: "self" | "team";
}

/** All counters come from the server's total for the selected window. */
export function EnrichmentPayoutSummary({ total, currency, scope }: EnrichmentPayoutSummaryProps) {
  const heading = scope === "team" ? "Team totals" : "My totals";
  const cards = [
    { label: "Processed", value: total.processed ?? "—" },
    { label: "Found", value: total.enriched },
    { label: "Not found", value: total.not_found },
    { label: "Total earnings", value: formatEnrichmentMoney(total.earnings, currency) },
  ];
  return (
    <section aria-label={heading} className="rounded-plane bg-white p-5 shadow-plane">
      <h3 className="mb-4 text-sm font-semibold text-slate-900">{heading}</h3>
      <dl className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {cards.map(({ label, value }) => (
          <div key={label} className="rounded-xl bg-slate-50 p-4">
            <dt className="text-xs text-slate-500">{label}</dt>
            <dd className="mt-2 text-2xl font-semibold tabular-nums text-slate-900">{value}</dd>
          </div>
        ))}
      </dl>
      <p className="mt-3 text-xs text-slate-500">
        Processed includes {total.corrections} unpaid corrections. Monetary adjustments add no record.
      </p>
    </section>
  );
}
